import { HTMLAttributes, useEffect, useState } from 'react'
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa'
import cl from 'classnames'
import styles from './styles.module.scss'
import { Button } from '../button'
import { Logo } from '@components/logo'

interface SocialDataProps {
  number: string
  text?: string
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  showFixedBarFrom?: number
  onClick?: () => void
  btnTitle: string
  whatsapp?: SocialDataProps
  phone?: string
}

export const FixedBar = ({
  showFixedBarFrom = 1000,
  onClick,
  btnTitle,
  whatsapp,
  phone,
  ...rest
}: Props) => {
  const [showFixedBar, setShowFixedBar] = useState(false)

  const normalizePhone = phone?.replace(/\D/g, '')

  const shareOnWhatsapp = () => {
    window.open(
      `https://api.WhatsApp.com/send?phone=${whatsapp?.number}&text=${whatsapp?.text}`,
      '_blank'
    )
    return false
  }

  const controlFixedBar = () => {
    if (window.scrollY > showFixedBarFrom) {
      setShowFixedBar(true)
    } else {
      setShowFixedBar(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', controlFixedBar)
    return () => window.removeEventListener('scroll', controlFixedBar)
  }, [])

  return (
    <div
      className={`${styles.container} ${showFixedBar && styles.visible}`}
      {...rest}
    >
      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <Logo />
        </div>

        <div className={styles.contactsWrapper}>
          {whatsapp && (
            <button
              type="button"
              className={styles.social}
              onClick={shareOnWhatsapp}
            >
              <p className={cl(styles.text, styles.whatsappText)}>Whatsapp</p>
              <FaWhatsapp className={styles.whatsappIcon} />
            </button>
          )}

          {phone && (
            <div className={styles.phone}>
              <p className={styles.text}>
                <a href={`tel:+${normalizePhone}`}>{phone}</a>
              </p>
              <FaPhoneAlt className="w-4 h-4 text-v2-eerie-black" />
            </div>
          )}
        </div>

        <div className={styles.wrapperButton}>
          <Button type="button" onClick={onClick}>
            {btnTitle}
          </Button>
        </div>
      </div>
    </div>
  )
}
